import { clsx } from "clsx";
import type React from "react";
import { useRef } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { useDistance } from "widgets/hooks";

import style from "./styles/TrackHeader.module.scss";

import { type IAppState } from "../../redux/reducer.js";
import { FEATURE_DISPLAY_NAME } from "../../settings/settings.js";

interface ITrackHeaderProps {
  title?: string;
  trackType?: string;
  subtitle?: string;
  trackIcons?: JSX.Element;
  hasLabel?: boolean | number; // Give a number to fix a pixel value. It's not yet responsive
  isTrackHovered?: boolean;
  noLabelsBottomMargin?: boolean;
  headerWidth?: number;
}

const TrackHeader: React.FC<React.PropsWithChildren<ITrackHeaderProps>> = (props) => {
  const width = useSelector<IAppState, number>((state) => state.genomeBrowser.layout.headerWidth, shallowEqual);

  const ref = useRef<HTMLDivElement>(null);
  const distance = useDistance(ref);

  return (
    <div className={style.track_header} style={{ width: props.headerWidth ?? width }}>
      {props.title && (
        // Absolute position
        <div
          ref={ref}
          className={clsx(style.track_name, { [style.track_name_transparent]: props.isTrackHovered && distance < 20 })}
          style={{ left: width }}
        >
          {props.title}
          {props.trackType && ` (${FEATURE_DISPLAY_NAME[props.trackType]})`}
          {props.subtitle && <span className={style.track_text_filename}> – {props.subtitle}</span>}
        </div>
      )}
      <div className={style.track_icons}>{props.trackIcons}</div>
      <div className={clsx(style.track_labels, { [style.track_labels_no_bottom_margin]: props.noLabelsBottomMargin })}>
        {props.children}
      </div>
    </div>
  );
};

export { TrackHeader };
